import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

function LogoMark() {
  return (
    <div data-testid="footer-logo">
      <img src="/lima-logo.png" alt="LIMA — Life Inside Media Academy" className="w-36 md:w-44" />
    </div>
  );
}

export default function Footer() {
  const links = [
    { label: "Program", hash: "#pipeline", testid: "footer-link-program" },
    { label: "Programs", hash: "#programs", testid: "footer-link-programs" },
    { label: "Admissions", hash: "#contact", testid: "footer-link-admissions" },
    { label: "About", hash: "#why", testid: "footer-link-about" },
  ];
  return (
    <footer className="bg-black border-t border-white/10 px-5 md:px-10 pt-16 md:pt-20 pb-8" data-testid="site-footer">
      <div className="grid md:grid-cols-12 gap-12 mb-12 md:mb-24">
        <div className="md:col-span-4">
          <LogoMark />
        </div>
        <div className="md:col-span-4 flex flex-col justify-center">
          <p className="text-sm text-white/60 leading-relaxed">
            Film school for the real world.
            <br />
            Backed by Life Inside Media &amp; Lime Studios.
          </p>
          <p className="mt-5 font-mono2 text-[11px] tracking-[0.12em] text-white/45 leading-loose">
            604, MONT VERT VELOCITY, BANER-PASHAN LINK RD, PUNE
            <br />
            <a href="tel:+918055316262" className="hover:text-white transition-colors duration-200">+91 80553 16262</a>
            {"  ·  "}
            <a href="mailto:academy@lifeinsidemedia.com" className="hover:text-white transition-colors duration-200">ACADEMY@LIFEINSIDEMEDIA.COM</a>
          </p>
        </div>
        <div className="md:col-span-4 flex md:justify-end items-start">
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {links.map((l) => (
              <button
                key={l.hash}
                onClick={() => scrollToId(l.hash)}
                data-testid={l.testid}
                className="text-sm text-white/70 hover:text-white transition-colors duration-200"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
      <div className="pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="font-mono2 text-[11px] tracking-[0.2em] text-white/40">
          © 2026 LIFE INSIDE MEDIA ACADEMY
        </p>
        <div className="flex items-center gap-6">
          <span className="font-mono2 text-[11px] tracking-[0.2em] text-white/40 flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-lima-red animate-rec" /> REC
          </span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="font-mono2 text-[11px] tracking-[0.2em] text-white/40 hover:text-white transition-colors duration-200">
            ADMIN
          </Link>
        </div>
      </div>
    </footer>
  );
}
